import { render, staticRenderFns } from "./DeliveryDetailsRow.vue?vue&type=template&id=e5815250&scoped=true"
import script from "./DeliveryDetailsRow.vue?vue&type=script&lang=ts"
export * from "./DeliveryDetailsRow.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryDetailsRow.vue?vue&type=style&index=0&id=e5815250&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5815250",
  null
  
)

export default component.exports